import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import FiltroNotasFiscais from "@/shared/view-models/Filtros/FiltroNotasFiscais";
import EmpresaController from "@/shared/controllers/empresa/empresaController";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import PedidoController from "@/shared/controllers/pedido/PedidoController";
import ProdutoController from "@/shared/controllers/produto/produtoController";


const name = 'NotasFiscais'

export default {
    name,

    components:{
        "g-button": gButton,
        "g-card": gCard,
    },

    props: { },
    watch: {
        objFiltros() {
          if (this.objFiltros.ClienteId == (undefined || null))
          {
            this.ClienteAgrupadorAtiva = true;
          }
         }
      },
    mounted() {
        this.UnidadeArray = EmpresaController.getEmpresasAtivas().EmpresaArray;
        this.popularDropDownEmpresa();
            this.mitt.on('trocaEmpresaRepresentante', () => {
            this.atualizaEmpresaRepresentante()
        })
        this.recebeNumeroPedido();
        this.StatusArray = PedidoController.GetStatusPedidoEnum().StatusArray;
        this.SituacaoArray = PedidoController.GetSituacaoEnum().SituacaoArray;
    },

    updated() { },

    data() {
        return {
            ClienteArray: [],
            ClienteSelecionado: null,
            EmpresaArray: [],
            ProdutoArray: [],
            ClienteAgrupadorAtiva: false,
            grid: true,
            codigoPedido : this.$route.params.codigoPedido,
            numeroParcela : this.$route.params.numeroParcela,
            NotasFiscaisArray: [],
            objFiltros: new FiltroNotasFiscais(),
            RepresentanteArray: [],
            StatusArray: [],
            SituacaoArray: [],
            UnidadeArray: [],
            Colunas : [
                {field: 'codigoExternoNF', header: 'Nota / Série'},
                {field: 'dataEmissaoFormatada', header: 'Emissão'},
                {field: 'sincronismoEnumTexto', header: 'Situação'},
                {field: 'valorTotalNotaFiscalFaturaFormatado', header: 'Valor (R$)'},
            ],

            Colunas2 : [],

            Filtro: {
                'global': {value: null, matchMode: this.filtros.CONTAINS},
                'codigoExternoNF': {value: null, matchMode:this.filtros.CONTAINS},
                'campoCliente_Pedido': {value: null, matchMode: this.filtros.CONTAINS},
                'campoRepresentante_Pedido': {value: null, matchMode: this.filtros.CONTAINS},
                '': {value: null, matchMode: this.filtros.CONTAINS},
                'dataEmissaoFormatada': {value: null, matchMode: this.filtros.CONTAINS},
                'sincronismoEnumTexto': {value: null, matchMode: this.filtros.CONTAINS},
            },
        }
    },

    methods: {
        getProduto(pesquisa) {
            window.clearTimeout(this.timer);
            this.timer = setTimeout(() => {
              ProdutoController.GetProdutoDropDownByPesquisaRepresentanteEmpresa(pesquisa, this.$store.state.representanteSelecionadoId, this.objFiltros.UnidadeId).requisicao
              .then((res) => {
                this.ProdutoArray = res.data.data
              })
              .catch(() => {
              })
            }, 1000);
        },
          
        buscar() {
            this.GetNotasFiscais()
        },


        GetNotasFiscais() {
            this.$isLoading(true)
            let EmpresaId = this.$store.state.empresaSelecionadaId;
            let RepresentanteId = this.$store.state.representanteSelecionadoId;

            PedidoController.GetNotasFiscais(RepresentanteId, EmpresaId, this.objFiltros).requisicao
            .then(response => {
                this.grid = false
                this.NotasFiscaisArray = response.data.data
            })
            .finally(() => {
                this.$isLoading(false)
            })
        },

        atualizaEmpresaRepresentante() {
            this.objFiltros.UnidadeId = this.$store.state.empresaSelecionadaId;
            this.representanteId = this.$store.state.representanteSelecionadoId;
        },

        buscarClientes(event) {
            window.clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.ClienteArray = ClienteController.GetAllClientesByEmpresaIdEFiltro(this.objFiltros.UnidadeId,event).ClientesArray;
            }, 1000);
        },

        telaDetalhes(data) {
            const rotaNovaAbaURL = this.$router.resolve({
                path: `/notas-fiscais-detalhes/${data.notaFiscalId}`
              }).href;
              
              window.open(rotaNovaAbaURL, '_blank');
        },

        limpar() {
            this.objFiltros = new FiltroNotasFiscais();
            this.ClienteArray = []
            EmpresaController.getEmpresasAtivas().requisicao
            .then(response => {
                this.UnidadeArray = response.data.data
                this.atualizaEmpresaRepresentante()
            })
            this.mitt.on('trocaEmpresaRepresentante', () => {
                this.atualizaEmpresaRepresentante()
            })
        },

        popularDropDownEmpresa(){
            this.EmpresaArray = this.$store.state.EmpresaArray;
            this.atualizaEmpresaRepresentante()
        },

        recebeNumeroPedido(){
            if(this.codigoPedido){
                this.objFiltros.NumeroPedido = this.codigoPedido;
                this.buscar();
            if(this.numeroParcela){
                this.objFiltros.NumeroPedido = this.codigoPedido;
                this.objFiltros.NumeroParcela = this.numeroParcela;
                this.buscar();
            }
            }
        },
        ativaClienteAgrupador() {
            this.ClienteAgrupadorAtiva = false;
          },
      // pedidosRota(data){
      //   this.$router.push(`pedido-em-andamento-fluxo/${data.id}/detalhes-pedido-andamento`)
      // },

      titulosRota(data){
        this.$router.push(`titulos/${data.codigoExternoNF}`)
      },

    },

    computed: { }
};